import { render, staticRenderFns } from "./CoopCompanySelectbox.vue?vue&type=template&id=42855c10"
import script from "./CoopCompanySelectbox.vue?vue&type=script&lang=js"
export * from "./CoopCompanySelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports